// /chat/$conversationId — the conversation list plus the open conversation
// (docs/plans/2026-09-30-runners/07-chat.md §2.8).

import { useState } from 'react'
import { useNavigate, useParams } from '@tanstack/react-router'
import type { ChatConversation } from '@goblic/shared'
import { ConversationList } from '../../components/chat/conversation-list'
import { ConversationView } from '../../components/chat/conversation-view'
import { NewConversationForm } from '../../components/chat/new-conversation-form'

export function ChatConversationPage() {
  // `from` addresses the route by id, which carries the pathless
  // `_authenticated` parent's id prefix (see router.tsx) even though the
  // actual URL has none — same convention as routes/runs/detail.tsx.
  const { conversationId } = useParams({ from: '/_authenticated/chat/$conversationId' })
  const navigate = useNavigate()
  const [newOpen, setNewOpen] = useState(false)

  function open(conversation: ChatConversation): void {
    void navigate({ to: '/chat/$conversationId', params: { conversationId: conversation.id } })
  }

  return (
    <div className="flex h-full">
      <div className="w-80 shrink-0 border-r border-line">
        <ConversationList activeId={conversationId} onSelect={open} onNew={() => setNewOpen(true)} />
      </div>
      <div className="min-w-0 flex-1">
        <ConversationView
          key={conversationId}
          conversationId={conversationId}
          layout="page"
          onDeleted={() => void navigate({ to: '/chat' })}
        />
      </div>
      <NewConversationForm open={newOpen} onClose={() => setNewOpen(false)} onCreated={open} />
    </div>
  )
}
